import { Heading } from "@tokenterminal/core/ui/heading/Heading"
import { Card } from "@tokenterminal/core/ui/layout/card/Card"
import DashboardImage from "modules/studio/components/DashboardImage"
import Link from "next/link"
import { type DashboardWithTag } from "../views/types"

export function RecentlyAdded({
  dashboards,
}: {
  dashboards: Array<DashboardWithTag>
}) {
  return (
    <Card className="rounded-2xl w-full p-6 lg:w-[380px]">
      <Heading level={4} className="mb-6">
        Recently added
      </Heading>
      <div className="flex flex-col gap-6">
        {dashboards.map(
          ({ user_dashboard_id, name, description, logo_url }) => (
            <Link
              key={user_dashboard_id}
              href={`/studio/dashboards/${user_dashboard_id}`}
              className="flex gap-3 items-start justify-start"
            >
              <DashboardImage
                size={16}
                imageAlt={name || "logo"}
                logoURL={logo_url}
                className="mt-0.5"
              />
              <div className="flex flex-col gap-1">
                <h4 className="text-sm font-medium">{name}</h4>
                <div className="text-sm text-fg-secondary line-clamp-2 text-ellipsis">
                  {description}
                </div>
              </div>
            </Link>
          )
        )}
      </div>
    </Card>
  )
}
